import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { History } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { DoorSnapshot } from "@/components/DoorSnapshot";

const fmt = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone: "America/New_York" });

export const UnlockHistory = ({ bookingId, testid }) => {
  const [open, setOpen] = useState(false);
  const { data, isLoading, error } = useQuery({
    queryKey: ["unlock-history", bookingId], enabled: open,
    queryFn: () => api.get(`/admin/bookings/${bookingId}/unlock-history`).then((r) => r.data),
  });
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testid} title="Who entered the studio" className="text-xs flex items-center gap-1 text-white/50 hover:text-[#D4AF37]">
          <History size={12} /> Entry log
        </button>
      </PopoverTrigger>
      <PopoverContent onInteractOutside={(e) => e.target.closest?.("[data-lightbox]") && e.preventDefault()} className="w-72 bg-[#111] border-white/10 text-white" data-testid={`${testid}-panel`}>
        <p className="text-sm font-display mb-1">Door unlocks</p>
        <p className="text-white/40 text-[11px] mb-3">From 1 hour before until 1 hour after the session</p>
        {isLoading && <p className="text-white/40 text-xs">Loading…</p>}
        {error && <p className="text-red-400 text-xs">{apiError(error)}</p>}
        {data && !data.enabled && <p className="text-white/40 text-xs">Smart lock not configured.</p>}
        {data?.enabled && data.entries.length === 0 && <p className="text-white/40 text-xs" data-testid={`${testid}-empty`}>No unlocks recorded in this window.</p>}
        <ul className="space-y-2 max-h-64 overflow-y-auto">
          {data?.entries.map((e, i) => (
            <li key={i} className="flex items-center gap-2 text-xs" data-testid={`${testid}-entry-${i}`}>
              {e.snapshot_id && <DoorSnapshot id={e.snapshot_id} label={`${e.this_booking ? "Client's door code" : e.method} · ${fmt(e.time)}`} testid={`${testid}-snap-${i}`} />}
              <span className={`flex-1 ${e.this_booking ? "text-[#D4AF37]" : "text-white/70"}`}>{e.this_booking ? "Client's door code" : e.method}</span>
              <span className="text-white/40 shrink-0">{fmt(e.time)}</span>
            </li>
          ))}
        </ul>
        {data && Object.keys(data.errors || {}).length > 0 && <p className="text-amber-400 text-[11px] mt-2">Some lock logs couldn't be loaded.</p>}
      </PopoverContent>
    </Popover>
  );
};
